import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {NetworkProvider} from '@shared/services/api/access-sites.interface';
import {Subject} from 'rxjs';
import {AceSelectComponent} from '../../ace-select/ace-select.component';
import {MessageTranslateService, NetworkProvidersService} from '@shared/services';
import {finalize} from 'rxjs/operators';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-network-provider-select',
  templateUrl: './network-provider-select.component.html',
  styleUrls: ['./network-provider-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NetworkProviderSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class NetworkProviderSelectComponent implements OnInit, ControlValueAccessor {

  readonly MAX_ITEMS = 3;

  selectedNetworkProviders: NetworkProvider[];
  networkProviders: NetworkProvider[];

  @Input()
  id: string;
  @Input()
  required: boolean;
  @Input()
  class: string;
  @Input()
  multiSelect = false;
  @Input()
  placeholder: string;

  loading: boolean;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  @ViewChild('aceSelect', { static: true })
  private aceSelect: AceSelectComponent;

  private onChange: (_) => void = (_) => {};
  private onTouched: () => void = () => {};

  constructor(private translateService: MessageTranslateService,
              private networkProvidersService: NetworkProvidersService) {
  }

  ngOnInit() {
    this.loading = true;
    this.networkProvidersService.getNetworkProviders(null, 0, 10000).pipe(finalize(() => this.loading = false))
      .subscribe((networkProviders) => {
        this.networkProviders = networkProviders.data;
      });

    if (this.placeholder === undefined) {
      this.placeholder = this.translateService.instant('Select Network Provider');
    }

    this.aceSelect.registerOnChange(this.aceSelectChange);
    this.aceSelect.registerOnTouched(this.aceSelectTouched);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

  aceSelectChange = (selected: NetworkProvider | NetworkProvider[]) => {
    this.updateSelectedValue(selected);
    this.onChange(selected);
  };

  aceSelectTouched = () => {
    this.onTouched();
  };

  writeValue(value: any): void {
    this.updateSelectedValue(value);
    this.aceSelect.writeValue(value);
  }

  compareFn(a: NetworkProvider, b: NetworkProvider): boolean {
    return a.network_provider_id === b.network_provider_id;
  }

  private updateSelectedValue(value: NetworkProvider | NetworkProvider[]): void {
    if (value) {
      if (Array.isArray(value)) {
        this.selectedNetworkProviders = value;
      } else {
        this.selectedNetworkProviders = [value];
      }
    } else {
      this.selectedNetworkProviders = <NetworkProvider[]>value;
    }
  }
}
